export default {
    baseUrl: 'http://120.25.103.193:20006/springboote9xw2/',
    indexNav: [
        {
            name: '首页',
            url: '/index/home'
        },
        {
            name: '出诊医生',
            url: '/index/chuzhenyisheng'
        },
        {
            name: '医院公告',
            url: '/index/news'
        },
    ]
}
